module.exports=function(scope){ return `<!-- enrolled successfully -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The FaceMap was successfully enrolled."
    },
    "data": {
        "auditTrailVerificationMessage": "...",
        "auditTrailVerificationStatus": 0,
        "createdDate": "2019-09-16T17:30:40+00:00",
        "enrollmentIdentifier": "foo",
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "faceMapType": 0,
        "glasses": false,
        "isEnrolled": true,
        "isLowQuality": false,
        "isReplayFaceMap": false,
        "livenessStatus": 0
    }
}

<!-- enrollment call with image data -->
<!-- creationStatus will only return when image data provided to process -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The FaceMap was successfully enrolled."
    },
    "data": {
        "auditTrailVerificationMessage": "...",
        "auditTrailVerificationStatus": 0,
        "createdDate": "2019-09-16T17:30:40+00:00",
        "creationStatus": 0,
        "enrollmentIdentifier": "foo",
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "faceMapType": 1,
        "glasses": true,
        "isEnrolled": true,
        "isLowQuality": false,
        "isReplayFaceMap": false,
        "livenessStatus": null
    }
}

<!-- enrollment failed because Liveness could not be determined -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The FaceMap was not enrolled because Liveness could not be determined."
    },
    "data": {
        "auditTrailVerificationMessage": "...",
        "auditTrailVerificationStatus": 0,
        "enrollmentIdentifier": "foo",
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "faceMapType": 1,
        "glasses": true,
        "isEnrolled": true,
        "isLowQuality": false,
        "isReplayFaceMap": false,
        "livenessStatus": 1
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point. -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/enrollment-post.json.tpl